<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="role" :rules="rules" :wrapper-col="{span:16}">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.roleNo')" prop="no">
              <vxe-input v-model="role.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.roleName')" prop="name">
              <vxe-input v-model="role.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.available')">
              <vxe-switch v-model="role.available"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <vxe-card>
      <template #title>
        <vxe-button content="business.label.roleAuthority" mode="text" status="primary"/>
      </template>
      <vxe-tree :check-node-keys.sync="checkNodeKeys" v-bind="treeOptions"/>
    </vxe-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findAll, findOne, save } from '@/api/Api'
import { Role } from '@/api/dto/admin/Role'

export default {
  data() {
    const treeOptions = {
      transform: true,
      showCheckbox: true,
      checkboxConfig: {
        highlight: true
      },
      nodeConfig: {
        isHover: true
      },
      data: []
    }
    return {
      treeOptions,
      enterprise: Vue.ls.get(ENTERPRISE),
      role: new Role(),
      loading: false,
      checkNodeKeys: [],
      rules: {
        no: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  created() {
    this.loading = true
    findAll('menuFactory', { available: true }).then(res => {
      this.treeOptions.data = res.result.map(item => {
        return { title: item.name, id: item.id, parentId: item.parent?.id }
      })
    }).finally(() => this.loading = false)
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(args) {
      this.checkNodeKeys = []
      this.loading = true
      findOne('roleFactory', args).then(res => {
        if (res.success) {
          this.role = new Role(res.result)
          this.checkNodeKeys = res.result.menus.filter(item => item.leaf).map(item => item.id)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.role = new Role()
      this.role.available = true
      this.checkNodeKeys = []
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const role = this.role.toJSONObject()
          role.enterprise = this.enterprise
          role.menus = this.checkNodeKeys.map(item => {
            return { id: item }
          })
          save('rolePersister', role).then(res => {
            if (res.success) {
              this.role = new Role(res.result)
              this.checkNodeKeys = res.result.menus.filter(item => item.leaf).map(item => item.id)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>